<!--
================================================
Un composant inclus dans NewTaskComp permettant de suggérer un liste de timerecords récents
Lorsque l'on clique un résultat, NewTaskComp est automatiquement hydraté

Url d'accès : http://localhost:8080/fr/random-company/timeTracking

================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="SuggestedTimerecordsComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}" v-show="isVisible">
      <div class="suggestedTimerecords" >

        <div v-for="(timerecord ,index) in suggestedTimerecords" class="suggestion" v-bind:class='{"activeSuggestion": indexCurrentActiveSuggestion === index}' v-on:click="emitTimerecordToCopy(timerecord)" v-on:keydown.enter="emitTimerecordToCopy(timerecord)" tabindex="0">

          <span class="taskNameSuggest">{{timerecord.taskName}}</span>
          <span class="project" v-if="timerecord.project!=null"  v-bind:title="$t('projet')">
            <font-awesome-icon v-bind:style="{color:'#'+ timerecord.project.color}" class="iconProjectSuggestion" :icon="['far', 'folder-open']"/>
            <span class="name">{{timerecord.project.name}}</span>
          </span>

          <span class="client" v-if="timerecord.project !=null && timerecord.project.client!=null"  v-bind:title="$t('client')">
            <font-awesome-icon :icon="['fas', 'user-tie']" class="iconClientSuggestion"/>
            <span class="name">{{timerecord.project.client.name}}</span>
          </span>

          <!-- affichage des tags  -->
          <span class="tagZone pl-2 ml-0 mr-5" v-if="timerecord.tags.length> 0"
                :content="$tc('xTags',timerecord.tags.length) + ' : '+ displayTagsInline(timerecord,0)"
                v-tippy="{theme:themeToDisplay=='dark' ? 'cronotipdark' : 'cronotip', trigger: 'mouseenter'}"
          >
            <span  class="has-text-grey-light tagCount " v-bind:title="$tc('xTags',timerecord.tags.length)">
            <!-- si un tag au moins est sélectionné affichage du nombre de tags sélectionnés -->
              {{timerecord.tags.length}}
                <font-awesome-icon  class="icon pt-2 ml-0" :icon="['fas', 'tag']"/>
            </span>
          </span>

          <span class="isBillable">
            <span v-if="timerecord.isBillable" v-bind:title="$t('facturable')"> <font-awesome-icon class="iconBillable" :icon="['fas', 'dollar-sign']"/>
</span>
          </span>
        </div>

      </div>

    </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SentryMixin from "../mixins/SentryMixin.js";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import TrackingMixin from "@/mixins/TrackingMixin";
    import _ from "lodash";
    import TagMixin from "@/mixins/TagMixin";

    export default {
        name: 'SuggestedTimerecordsComp', //utile dans vue dev tool
        mixins: [
            GlobalErrorNotification,
            SentryMixin,
            InterceptorMixin,
            TrackingMixin, TagMixin
        ],
        // components: {},

        // props: {
            // pour typage voir :https://fr.vuejs.org/v2/guide/components-props.html#Types-des-props
            // placeholder : String, // attribut placeholder du champ
        // },
        data: function () {
            return {
                locale : this.$route.params.locale,
                isVisible : false, // bool | la visibilité du composant
                // pour les composants où l'user est identifié ///////////////////////
                // organizationSlug: this.$route.params.organization
                // userSlug: JSON.parse(this.$cookie.get('auth')).userSlug (ou dispo dans this.$auth.getUserSlug())
                // componentIsReady : false, // indique quand le composant est prêt à être affiché
                // =================================================================
              suggestedTimerecords: [], // Un array d'objets timerecords pour la suggestion
              indexCurrentActiveSuggestion: 0, // int | l'index de la suggestion actuellement affichée comme focusée
              taskNameFilter: ''// string | une string pour filtrer les timerecords sur leurs champs taskName

            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                user: state => state.user,
                themeToDisplay: state => state.app.themeToDisplay
          }),

            //----------------------------------------------

            // other computed props :
            //  le nombre de suggestions
            suggestionCount: {
              get: function () {
                return (this.suggestedTimerecords.length != null)
                    ? (this.suggestedTimerecords.length -1 ) : null //@todo Je ne suis plus sûr en fin de dev de la raison pour laquelle j'ai mis -1, à vérifier
              },
                // set: function (newValue) {this.foo = newValue}
            }

        },
        watch: {
            // à chaque fois que la prop computed change, cette fonction s'exécutera
            indexCurrentActiveSuggestion: function () { // met à jour l'index du tr suggéré actuellement actif, permet au NewTaskComp de savoir s'il faut bypasser l'envoi du form avec enter ou non
              this.$store.commit('UpdateTimeTrackingSuggestedTrIndexCurrentActive', this.indexCurrentActiveSuggestion);
            },

        },

        methods: {

          /**
           * Récupère les suggestions de timerecords (avec debounce)
           *
           * @param String filter | une chaîne pour filtrer par taskname
           */
          loadDebounceSuggestions: _.debounce(
              function() {
                // this.isSubmiting = true
                let self = this;

                let userSlug= self.user.slug;
                if(_.isEmpty(userSlug)){userSlug=JSON.parse(this.$cookie.get('auth')).userSlug ;}    // Au cas où le slug serait vide (à cause du temps d'accès au store, copié du fix du bug #326 de loadProjects)

                self.$http.get(
                    `organizations/${self.$auth.getOrganization()}/users/${userSlug}/timeRecords`,
                    {
                      params: {
                        filter: this.taskNameFilter,
                        excludeDuplicates: true,
                        limit: 50,
                        sort: "desc", // les + récents en premier
                      },
                      headers: {Authorization: self.$auth.header()},

                    }
                )
                    .then(function (response) {
                      self.isVisible = true

                      if (response.data.length == 0){
                        self.isVisible = false;
                        // self.indexCurrentActiveSuggestion = 0
                      }
                      self.indexCurrentActiveSuggestion = -1 // reset de la suggestion

                      self.$store.commit('UpdateTimeTrackingSuggestedTrTimerecords', response.data) // on sauvegarde les timerecords suggérés dans le store, (requis pour compter le nombre de suggestion dans newTaskComp )
                      self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                    // @todo Si + tard on veut ajouter des suggestions de projets/clients voir ici comment les tr sont groupés dans projectsGroupedByClient dans ProjectSelectorComp

                      self.suggestedTimerecords = response.data;

                    })
                    .catch(function (error) {
                      // On catch ici sauf ce qui relève des intercepteurs Axios
                      if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
                        self.logToSentry(self, error, 'error')
                        let errorCode = '0050' ; let errorDetail = "error fetching suggested timerecords"
                        self.showGlobalErrorNotif(self,errorCode)
                        self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": errorDetail})
                        self.$gtag.exception({'description': 'error '+errorCode + ' | '+errorDetail, 'fatal': false})
                        self.$sentry.captureMessage(`Error ${errorCode} > "${errorDetail} : ${error}`, 'error')

                      }
                    })
                    .then(() => {
                      // toujours exécuté

                    })
              }, 200),
          /**
           * Émet un event pour indiquer au NewTaskComp de copier le timerecord passé en paramètre
           *
           * @param object timerecord | le timerecord suggéré à copier
           */
          emitTimerecordToCopy: function(timerecord){
            this.$root.$emit('copy_suggested_timerecord',timerecord)
            this.isVisible = false
          },

          /**
           * Passe la suggestion active à la suivante dans la liste
           */
          nextItem: function(){
            if(this.indexCurrentActiveSuggestion == this.suggestionCount ){
              this.indexCurrentActiveSuggestion=0
            }else{
              this.indexCurrentActiveSuggestion++
            }
          },
          /**
           * Passe la suggestion active à la suivante dans la liste
           */
          prevItem: function(){
            if(this.indexCurrentActiveSuggestion == 0){
              this.indexCurrentActiveSuggestion= this.suggestionCount
            }else{
              this.indexCurrentActiveSuggestion--
            }
          },




        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {
            // this.logToSentry(this, 'push a log to sentry :)', 'info')

          this.$root.$on('timerecord_suggestions_required', (taskNameFilter) => {

            this.taskNameFilter = taskNameFilter
            this.loadDebounceSuggestions(taskNameFilter)

            })


            // si taskName est vidé dans NewTaskNom on masque les suggestions
            this.$root.$on('new_task_comp_taskName_empty', () => {
              this.isVisible=false
            })
           // Si NewTaskComp envoi un event timerecords_suggestions_scroll_down
            this.$root.$on('timerecords_suggestions_scroll', (direction) => {
              switch (direction) {
                case  'down': this.nextItem() ;break;
                case  'up': this.prevItem() ;break;
              }
            })

          // Si NewTaskComp envoi un event copy_current_suggested_tr_to_new_task pour demander le tr à copier on le renvoit via un event (sert à la sélection du tr avec "entrer")
            this.$root.$on('copy_current_suggested_tr_to_new_task', () => {
              this.$root.$emit('copy_suggested_timerecord',this.suggestedTimerecords[this.indexCurrentActiveSuggestion])
              // this.copySuggestedTimerecord(this.suggestedTimerecords[this.indexCurrentActiveSuggestion])
              this.isVisible = false
            })
          // Si NewTaskComp envoi un event hide_suggested_timerecords on masque le comp
            this.$root.$on('hide_suggested_timerecords', () => {
              this.isVisible = false
            })
          // Si NewTaskComp envoi un event new_task_comp_click_outside on masque le comp
            this.$root.$on('new_task_comp_click_outside', () => {
              this.isVisible = false
            })

        },
      beforeDestroy () {
        /**
         * On supprime le listener sur "timerecord_suggestions_required"
         * Évite un bug qui faisait que l'event "timerecord_suggestions_required" était envoyé 2 fois aprés 2 création de tr depuis une suggestion (3 après 3 etc.)
        Cette solution est inspirée de https://stackoverflow.com/a/61049328/666416 et https://charlietheprogrammer.com/duplicate-vue-event-listeners-and-how-i-solved-them
         **/
        this.$root.$off('timerecord_suggestions_required')

        // évite que 2 tr en cours soit ajoutés dans TaskTimerecordListComp
        this.$root.$off('copy_current_suggested_tr_to_new_task')

      },
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    @import "../assets/css/bulmaResponsiveDep.scss";

    #SuggestedTimerecordsComp{

      //////////////////////////////////////////
      // LIGHT THEME ///////////////////////////

      .suggestedTimerecords{
        border: solid 3px $brandFourth;
        border-top:none;
        box-shadow:  0 3px 6px #ccc;
        background-color: #fff;
        position: absolute;
        top: 7.55rem;
        right: 0; left: 0;
        z-index: 40;

        .suggestion{
          text-align: left;
          border-bottom: solid 1px #eee;
          border-left: solid 6px transparent;
          padding: 0.95rem;
          padding-left: 2rem;
          transition: background-color 300ms ease;
          transition: border 300ms ease;



          @include touch{
            padding-left: 0.5rem;
          }
          &:hover{ cursor: pointer;
            //background-color: #f9f9f9;
          }
          &.activeSuggestion {
            background-color: #f9f9f9;
            //border-left: solid 1px $brandBlue;
            cursor: pointer;
            color:$brandBlue !important;
            .taskNameSuggest{color: $brandBlue !important;}
            &:before{
              content: " >";
              position: absolute; left: 1rem;
              padding-right: 1rem; font-size: 1.2rem;
              color: $brandBlue; font-weight: bold;
              @include touch{ display: none;}

            }
          }
          .taskNameSuggest{
            font-size: 0.95rem;
            color: $brandThird;
            display: inline-block ;
            font-weight: bold;
            margin-right: 2rem;
            @include touch {
              display: block;
              margin-bottom: .3rem;
            }
          }
          .project{
            display: inline-block ;
            margin-right: 2rem;
            font-size: 0.9rem;
            color: #777;
            //font-weight: bold;

            @include touch {
              //display: block;
              font-size: 0.8rem;
              margin-right: 1rem;
            }
            .iconProjectSuggestion{
              margin-right: 0.3rem;
              font-size: 0.9rem;
              color: #777;
            }



          }
          .client{
            margin-right: 2rem;
            .name{color: $brandFourth;font-size: 0.9rem;}
            @include touch {
              margin-right: 1rem;
              //display: block;
              font-size: 0.8rem;
              .name{
                font-size: 0.8rem;

              }
            }
            .iconClientSuggestion{
              margin-right: 0.5rem;
              color:$brandFourth
            }

          }
          .isBillable{
            .iconBillable{
              display: inline-block;
              font-size: 0.9rem;
              color: $brandPrimary !important;
            }

          }
        }
      }

      /////////////////////////////////////////
      // DARK THEME ///////////////////////////
      &.darkMode {
        .suggestedTimerecords{
          $suggestionBgColor: $darkBg4;
          background-color: $suggestionBgColor;
          box-shadow:  0 0 5px 1px #222;
          border-color: lighten($suggestionBgColor,25%);

          .suggestion{
            border-bottom-color: lighten($suggestionBgColor,9%);
            &:last-child{border-bottom-color: transparent}
            //&:hover {background-color: lighten($suggestionBgColor,4%)}
            &.activeSuggestion {
              background-color: lighten($suggestionBgColor,4%);
              .taskNameSuggest{color: white !important;}
              &:before{
                content: " >";
                color: $brandPrimary;
                @include touch{ display: none;}
              }
            }

            .taskNameSuggest{
              color:$darkContrastTxt;
            }
            .project{
              color: $darkTxt;
            }
            .client .name, .client .iconClientSuggestion{
              color: #999 !important;
            }
          }
        }

      }

    }
</style>
